import { Button, Card, Flex, rem, Text } from "@mantine/core";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import ReactGA from 'react-ga';
import InstallmentHeader from "./header";
import InstallmentSteps from "./steps";


const InstallmentTopContractors = dynamic(() => import("./top-contractors"));
const InstallmentCalculate = dynamic(() => import("./calculate"));
const InstallmentFAQ = dynamic(() => import("./faq"));




const InstallmentLanding = () => {

    const router = useRouter()

    const actionFooterClicHandler = () => {
        ReactGA.event({
            category: 'product',
            action: 'Click',
            label: 'sticky-cta'
        });

        router.push("/product?service_type=cabinet&form_type=installment-page-sticky-cta&title=%D8%A8%D8%B1%D8%A7%DB%8C%20%D8%AF%D8%B1%DB%8C%D8%A7%D9%81%D8%AA%20%D9%82%DB%8C%D9%85%D8%AA%20%D8%AF%D9%82%DB%8C%D9%82%20%D9%BE%D8%B1%D9%88%DA%98%D9%87%20%D8%AA%D8%A7%D9%86%20%D8%A7%D8%B2%20%DA%A9%D8%A7%D8%B1%D8%B4%D9%86%D8%A7%D8%B3%D8%A7%D9%86%20%D9%85%D8%A7%D8%8C%20%D8%A8%D9%87%20%DA%86%D9%86%D8%AF%20%D8%B3%D9%88%D8%A7%D9%84%20%D9%BE%D8%A7%D8%B3%D8%AE%20%D8%AF%D9%87%DB%8C%D8%AF:&unstructured_data=price")
    }


    return (
        <section className="IRANSans">
            <InstallmentHeader />
            <InstallmentSteps />
            <InstallmentTopContractors />
            <InstallmentCalculate />
            <InstallmentFAQ />

            <Card
                radius="12px 12px 0 0"
                bg="linear-gradient(270deg, rgba(1, 48, 162, 0.90) 0%, rgba(1, 27, 88, 0.90) 100%)"
                pos="fixed"
                bottom={0}
                left={0}
                right={0}
                py={{ base: "xs", sm: "md" }}
                style={{ zIndex: 2, backdropFilter: "blur(1.5px)" }}
                onClick={actionFooterClicHandler}
                id="installment-page-sticky-cta"
            >
                <Flex
                    className="container"
                    align="center"
                    justify="space-between"
                    w="100%"
                >
                    <Text
                        fz={{ base: rem(12), sm: rem(20) }}
                        c="white"
                        fw={600}
                    >
                        دریافت قیمت و شرایط اقساط
                    </Text>

                    <Button
                        variant="white"
                        c="blue.1"
                        fz={{ base: rem(10), sm: rem(14) }}
                    >
                        دریافت قیمت
                    </Button>
                </Flex>
            </Card>
        </section>
    )
}

export default InstallmentLanding